"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions = __importStar(require("./articlesActions"));
var defaultState = {
    categoriesAreLoading: false,
    bountiesAreLoading: false,
    promosAreLoading: false,
    currentCategory: {},
    categories: [],
    promos: []
};
function reducer(state, action) {
    if (state === void 0) { state = defaultState; }
    var payload = action.payload;
    switch (action.type) {
        case actions.getAllCategories.TRIGGER: {
            return __assign(__assign({}, state), { categoriesAreLoading: true });
        }
        case actions.getAllCategories.SUCCESS: {
            localStorage.setItem('trybe_categories', JSON.stringify(payload));
            return __assign(__assign({}, state), { categories: payload, categoriesAreLoading: false });
        }
        case actions.getAllCategories.FAILURE: {
            return __assign(__assign({}, state), { categoriesAreLoading: false });
        }
        case actions.getAllBounties.TRIGGER: {
            return __assign(__assign({}, state), { bountiesAreLoading: true });
        }
        case actions.getAllBounties.SUCCESS: {
            localStorage.setItem('lo0p_bounties', JSON.stringify(payload));
            return __assign(__assign({}, state), { bounties: payload, bountiesAreLoading: false });
        }
        case actions.getAllBounties.FAILURE: {
            return __assign(__assign({}, state), { bountiesAreLoading: false });
        }
        case actions.changeCategory.TRIGGER: {
            return __assign(__assign({}, state), { currentCategory: payload });
        }
        case actions.getAllPromos.TRIGGER: {
            return __assign(__assign({}, state), { promosAreLoading: true });
        }
        case actions.getAllPromos.SUCCESS: {
            localStorage.setItem('trybe_promos', JSON.stringify(payload === null || payload === void 0 ? void 0 : payload.acf.featured_articles));
            return __assign(__assign({}, state), { promos: payload === null || payload === void 0 ? void 0 : payload.acf.featured_articles, promosAreLoading: false });
        }
        case actions.getAllPromos.FAILURE: {
            return __assign(__assign({}, state), { promosAreLoading: false });
        }
        default:
            return state;
    }
}
exports.default = reducer;
